<template>
  <div class="product_tab_1 outer_tab">
    <!--收起内容-->
    <div class="pulldownbox info-container" v-show="!showQueryFilter">
      <i class="el-icon-info"></i>
      <span>查询条件</span>
      <span class="pulldownbtn" @click="pulldown"
        >展开<i class="el-icon-arrow-down"></i
      ></span>
    </div>
    <!--展开内容-->
    <div
      style="width: 100%"
      class="expandbox info-container"
      v-show="showQueryFilter"
    >
      <el-form
        class="product_filter_form"
        :model="filterForm"
        inline
        ref="filterForm"
        size="small"
        label-width="100px"
      >
        <el-form-item label="适用区域:" prop="qhdm">
          <!--县乡村 联动-->
          <el-cascader
            style="height: 40px"
            class="textInput"
            v-model="filterForm.qhdmValue"
            :options="areaOptions"
            :props="areaProps"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="发布标题:" prop="title">
          <el-select
            v-model="filterForm.title"
            placeholder="请选择发布标题"
            class="textInput"
            filterable
          >
            <el-option
              v-for="item in titleList"
              :key="item.id"
              :label="item.titile"
              :value="item.titile"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:" prop="status">
          <el-select
            v-model="filterForm.status"
            placeholder="请选择状态"
            class="textInput"
          >
            <el-option
              v-for="item in statusList"
              :key="item.status"
              :label="item.label"
              :value="item.status"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-row style="text-align: center; margin: 5px 0">
        <el-button @click="queryBtnClick" type="primary" size="small"
          >查询</el-button
        >
        <el-button @click="resetFilter" type="primary" plain size="small"
          >重置</el-button
        >
        <span class="pullupbtn" @click="pullup"
          >收起<i class="el-icon-arrow-up"></i
        ></span>
      </el-row>
    </div>
    <div
      style="height: 100%; position: relative"
      class="tablebox info-container"
    >
     <!--总计内容-->
      <el-row class="count_content">
        <i class="el-icon-success icon-table-summary"></i>
        <span
          >共查询到
          <span class="count_number">{{ totalItems }}</span> 条数据</span
        >

        <div
          style="display: inline-block; float: right; padding-right: 10px"
        >
          <el-button type="primary" size="small" @click="add()"
            >新增</el-button
          >
        </div>
      </el-row>

      <!--table-->
      <div style="height: 100%; position: relative">
        <el-table
          class="product_tab_1_table"
          :data="tableData"
          ref="dataTable"
          @current-change="handleCurrentChange"
          height="100%"
          highlight-current-row
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="qhmc"
            label="适用区域"
            min-width="30"
            :formatter="formatterFn"
          ></el-table-column
          ><el-table-column
            prop="titile"
            label="文件名称"
            min-width="30"
            :formatter="formatterFn"
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="截止日期"
            min-width="30"
            :formatter="formatterDate"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            min-width="25"
            :formatter="formatterFn"
          >
          <template slot-scope="scope" >
              <span v-if="scope.row.status==1">待发布</span>
              <span v-if="scope.row.status==2">申报中</span>
              <span v-if="scope.row.status==3">已截止</span>
          </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope" >
              <div class="template-slot-scope">
                <el-tooltip
                  class="item"
                  content="发布"
                  placement="top"
                  v-if="scope.row.qhdm.length>= areaCode.length && scope.row.status == 1"
                >
                  <i
                    class="table-icon el-icon-s-promotion"
                    style="color:#00955B;"
                    @click="publishProduct(scope.row)"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="提前截止申报"
                  placement="top"
                  v-if="scope.row.qhdm.length>= areaCode.length && scope.row.status == 2"
                >
                  <i
                    class="table-icon el-icon-switch-button"
                    style="color:#00955B;"
                    @click="productDown(scope.row)"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="延迟截止时间"
                  placement="top"
                  v-if="scope.row.qhdm.length>= areaCode.length && scope.row.status == 3"
                >
                  <i
                    class="table-icon el-icon-timer"
                    style="color:#00955B;"
                    @click="delayDialogOpen(scope.row)"
                  ></i>
                </el-tooltip>
                <el-tooltip class="item" content="详情" placement="top">
                  <i
                    class="table-icon el-icon-document"
                    @click="detail(scope.row)"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="编辑"
                  placement="top"
                  v-if="scope.row.qhdm.length>= areaCode.length && scope.row.status == 1"
                >
                  <i
                    class="table-icon el-icon-edit-outline"
                    @click="edit(scope.row)"
                  ></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="top"
                  v-if="scope.row.qhdm.length>= areaCode.length && scope.row.status != 2"
                >
                  <i
                    class="table-icon el-icon-delete"
                    @click="deleteItem(scope.row)"
                  ></i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页工具-->
      <el-row class="page-row">
        <el-pagination
          background
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="currentChange"
          layout="prev, pager, next, jumper"
          :total="totalItems"
        >
        </el-pagination>
      </el-row>

      <el-dialog
        title="延迟截止时间"
        :visible.sync="delayDialogVisble"
        width="60%"
      >
        <el-form :model="delayForm" :rules="rules" ref="delayDialog" label-width="100px">
          <el-form-item prop="time" label="截止时间">
            <el-date-picker :picker-options="pickerOptions" placeholder="请选择截止时间" v-model="delayForm.time" type="date"></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="delayDialogVisble = false">取 消</el-button>
          <el-button type="primary" @click="delayConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <agrotechnicalSchemeDetail ref="agrotechnicalSchemeDetail"></agrotechnicalSchemeDetail>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import API from "@/api/api_project/api_project";

import agrotechnicalSchemeDetail from "./components/details.vue";

export default {
  components: {
    agrotechnicalSchemeDetail
  },
  name: "publish-list",
  data() {
    return {
      rules: {
        time: [
          { required: true, message: "请选择截止时间", trigger: "blur" },
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      delayForm: {
        time: ''
      },
      delayDialogVisble: false,
      //区域参数
      areaOptions: [],
      areaCode: Cookies.get("curAreaCode"),
      updateBy: Cookies.get('username') || '',
      areaProps: {
        label: "qhmc",
        value: "qhdm",
        children: "children",
        checkStrictly: true,
      },
      titleList: [],
      filterForm: {
        qhdmValue: [Cookies.get("curAreaCode")], // 区域
        title: "", // 发布标题
        status: "", // 状态
      },
      currentPage: 1 /*分页工具当前选中页*/,
      pageSize: 10,
      totalItems: 0 /*数据总条数*/,
      showQueryFilter: true /*是否显示搜索条件*/,
      currentRow: "" /*当前选中的table行*/,
      tableData: [] /*table数据源*/,
      params: {}, // 查询参数
      // 已通过：1，待初审：4，待复审：8，驳回：5，异常：6，注销：7
      statusList:[
        {
          label:'待发布',
          status:1
        },
        {
          label:'申报中',
          status:2
        },
        {
          label:'已截止',
          status:3
        },
      ],
    };
  },
  created() {
    this.GLOBAL.eventBus.$on("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$on("firstLoadAreaOption", this.getNextXzqData); //
    this.GLOBAL.eventBus.$on("refreshPublishList", this.init)
  },
  beforeDestroy() {
    this.GLOBAL.eventBus.$off("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$off("firstLoadAreaOption", this.getNextXzqData);
    this.GLOBAL.eventBus.$off("refreshPublishList", this.init) //
  },
  mounted() {
    this.init();
  },
  methods: {
    add() {
      this.$refs.agrotechnicalSchemeDetail.show(null, "add");
    },
    edit(row) {
      this.$refs.agrotechnicalSchemeDetail.show(JSON.parse(JSON.stringify(row)), "edit");
    },
    detail(row) {
      this.$refs.agrotechnicalSchemeDetail.show(JSON.parse(JSON.stringify(row)), "detail");
    },
    // 截止时间确定
    delayConfirm() {
      let that = this
      this.$refs.delayDialog.validate(async(valid) => {
        if (valid) {
          let res = await API.setInformationEndTime({
            id: that.currentRow.id,
            endTime: that.delayForm.time,
            updateBy: that.updateBy
          })

          if (res.code == 0) {
            this.$message({ type: "success", message: "修改成功" })
            this.delayDialogVisble = false
            this.getPublishList()
          } else {
            this.$message({
              type: "warning",
              message: res.msg || "修改失败"
            });
          }
        }
      });
    },

    // 截止弹框打开
    delayDialogOpen(row) {
      this.currentRow = JSON.parse(JSON.stringify(row))
      this.delayDialogVisble = true
      this.delayForm.time = ''
      this.$nextTick(() => {
        this.$refs.delayDialog.clearValidate()
      })
    },

    deleteItem(row) {
      this.$confirm(
        '确定要删除此条数据吗？',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          await API.informationDelete({ id: row.id }).then(res => {
            if (res.code == 0) {
              this.$message({ type: "success", message: "删除成功" });
              this.getPublishList();
            } else {
              this.$message({
                type: "warning",
                message: res.msg || "删除失败"
              });
            }
          });
        })
        .catch((err) => {console.error(err)});
    },
    // 提前截止申报
    productDown(row) {
      let that = this;
      this.$confirm(
        '确定要提前截止申报吗？',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          let temp = {
            id: row.id,
            status: 3,
            updateBy: that.updateBy
          }
          await API.setInformationStatus(temp).then(res => {
            if (res.code == 0) {
              this.$message({ type: "success", message: "提前截止申报成功" });
              this.getPublishList();
            } else {
              this.$message({
                type: "warning",
                message: res.msg || "提前截止申报失败"
              });
            }
          });
        })
        .catch(() => {});
    },
    // 发布
    publishProduct(row) {
      let that = this;
      this.$confirm(
        '为避免信息错误，项目发布后信息将不可修改。请认证核对项目内容，确保无误',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          dangerouslyUseHTMLString: false,
        }
      )
        .then(async () => {
          let temp = {
            id: row.id,
            status: 2,
            updateBy: that.updateBy
          }
          await API.setInformationStatus(temp).then(res => {
            if (res.code == 0) {
              this.$message({ type: "success", message: "发布成功" });
              this.getPublishList();
            } else {
              this.$message({
                type: "warning",
                message: res.msg || "发布失败"
              });
            }
          });
        })
        .catch(() => {});
    },

    formatterFn(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return cellValue;
    },

    formatterDate(row, column, cellValue, index) {
      if (!cellValue) {
        return "--";
      }
      return this.GLOBAL.timetoDate(Date.parse(cellValue), 'date');
    },

    /*页面初始化*/
    init() {
      this.getParams();
      this.getPublishList();
      this.getNextXzqData();
      this.getTitleList();
    },

    //获取区域数据
    async getNextXzqData() {
      let regionOption = localStorage.getItem("areaOptions"); //获取乡级以上区域信息
      if (regionOption) {
        this.areaOptions = [JSON.parse(regionOption)];
      }
    },

    // 标题接口
    async getTitleList() {
      let { code, data } = await API.getTitleList({
        titile: this.filterForm.title,
        qhdm: this.filterForm.qhdmValue[this.filterForm.qhdmValue.length - 1]
      });
      if (code === 0) {
        if (data && data.list && data.list.length) {
          this.titleList = data.list
        }
      }
    },

    //  参数设置
    getParams() {
      let form = this.filterForm;

      this.params = {
        // 参数
        qhdm: form.qhdmValue[form.qhdmValue.length - 1],
        page: this.currentPage, // 页数
        titile: form.title, // 标题
        status: form.status, // 状态
        pageSize: this.pageSize
      };
    },

    // 列表接口
    async getPublishList() {
      const { code, data } = await API.getInformationList(this.params);
      if (code === 0) {
        this.totalItems = data.count;
        this.tableData = data.list;
      }
    },

    /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val;
      this.getParams();
      this.getPublishList();
    },

    /*点击查询按钮*/
    queryBtnClick() {
      this.currentPage = 1;
      this.getParams();
      this.getPublishList();
    },

    /*点击重置按钮*/
    resetFilter() {
      this.currentPage = 1; // 页数
      this.filterForm.title = ""; // 名称
      this.filterForm.qhdmValue = [Cookies.get("curAreaCode")]; // 区域
      this.filterForm.status=''
      this.getParams()
      this.getPublishList()
    },
    /*table选中行回调方法*/
    handleCurrentChange(val) {
      this.currentRow = val;
    },

    /*收起按钮*/
    pullup() {
      this.showQueryFilter = false;
    },

    /*展开按钮*/
    pulldown() {
      this.showQueryFilter = true;
    },
  },
};
</script>
<style lang="less">
el-dialog__header {
  background: red;
  text-align: center;
}
.dialog-footer{
  text-align: center;
}
.icon-zhuxiao{
  color: red;
}
.el-icon-warning-outline{
  color: #F89E01;

}
.template-slot-scope{
  // width: 100%;
  display: flex;
  align-items: center;
  // text-align: center;
  // justify-content: space-around;
}
.box_total{
  height: 50px;
  border: 1px solid #EEF0F3;
  width: 23%;
  margin: 10px;
  background: #FFFFFF;
  box-shadow: 0px 0px 44px 0px rgba(118,134,182,0.1400);
  border-radius: 5px;
   display: flex;
  justify-content: space-around;
  align-items: center;

}
.bg{
   border: 1px solid #2A8852;
   color: #2A8852;
}
</style>




// WEBPACK FOOTER //
// src/studio/publish/publishList.vue